import classNames from 'classnames';
import { Field, Form } from 'react-final-form';
import { Button, Col, Row } from 'reactstrap';
import { actions } from '../../../context';

const PimsConfiguration = (props) => {
    const { config, editing, refresh, dispatch } = props;

    const submit = async (vals) => {
        const payload = { ...vals };
        dispatch(actions.pims.updatePimsConfig(payload)).then(
            async () => await refresh()
        );
    };

    return (
        <tr className="border-top border-bottom">
            <td className="border-right">{config.key || 'KEY'}</td>
            <td>
                {editing ? (
                    <Form
                        initialValues={config}
                        onSubmit={submit}
                        render={({
                            handleSubmit,
                            form,
                            submitting,
                            pristine,
                            values,
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Row>
                                    <Col>
                                        {(config.value || '').length > 12 ? (
                                            <Field
                                                className="w-100 rounded p-2 border mb-2"
                                                component="textarea"
                                                name="value"
                                                rows="4"
                                            />
                                        ) : (
                                            <Field
                                                className="w-100 rounded p-2 border mb-2"
                                                component="input"
                                                name="value"
                                            />
                                        )}
                                    </Col>
                                </Row>
                                {!pristine && (
                                    <Row>
                                        <Col className="text-right">
                                            {!pristine && (
                                                <Button
                                                    color="danger"
                                                    onClick={form.reset}>
                                                    Cancel
                                                </Button>
                                            )}
                                            &emsp;
                                            <Button
                                                color="success"
                                                type="submit"
                                                disabled={submitting}>
                                                Save
                                            </Button>
                                        </Col>
                                    </Row>
                                )}
                            </form>
                        )}
                    />
                ) : (
                    <span
                        className={classNames({
                            'text-warning': !config.value,
                        })}>
                        {(config.value || 'NULL')
                            .replace(/;/gi, '; ')
                            .replace(/\|\|\|\|/gi, ' |||| ')}
                    </span>
                )}
            </td>
        </tr>
    );
};

export default PimsConfiguration;
